import { useTheme } from '@mui/material/styles';
import { Button, Card, Grid, Typography } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { ThemeMode } from 'config';
import Avatar from 'ui-component/extended/Avatar';
import { OpenInNewOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router';
import { getBackgroundColor } from 'Application/utils';

interface AgencyCardProps {
    about: string;
    avatar: string;
    contact: string;
    email: string;
    address: string;
    name: string;
    role: string;
    id: number;
}

const getInitials = (name: string) => {
    const words = name.split(' ').filter((word) => word !== '');
    return words.length > 1 ? words[0][0] + words[1][0] : words[0][0];
};

export const AgencyCard: React.FC<AgencyCardProps> = ({ about, avatar, contact, email, address, name, role, id }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const urlLocation = useLocation();
    const navigateToAgency = () => {
        navigate(`${urlLocation.pathname}/agency/${id}`);
    };

    const initials = getInitials(name);
    const backgroundColor = getBackgroundColor(initials[0]); // Get background color based on the first letter

    return (
        <Card
            sx={{
                p: 2,
                bgcolor: theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'white',
                border: '1px solid',
                borderColor: 'divider'
            }}
            className="shadow-sm hover:shadow-lg"
        >
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs zeroMinWidth>
                            <Avatar
                                className={`border border-gray-200 ${backgroundColor}`}
                                alt={name}
                                size="lg"
                                color={''}
                                outline={undefined}
                                sx={undefined}
                            >
                                {initials}
                            </Avatar>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h3">{name}</Typography>
                    <Typography variant="caption">{role}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="caption">Email</Typography>
                    <Typography variant="h6">{email}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={6}>
                            <Typography variant="caption">Phone</Typography>
                            <Typography variant="h6">{contact}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption">Location</Typography>
                            <Typography variant="h6">{address}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Button onClick={navigateToAgency} color="secondary" variant="outlined" fullWidth startIcon={<OpenInNewOutlined />}>
                        View
                    </Button>
                </Grid>
            </Grid>
        </Card>
    );
};
